import { GetCmSheetAvailableCertificationsResponse } from "../../../types/api/collaborators.type";
import { QueryParam } from "../../../types/api/generic.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const CmSheetAvailableCertificationsService = {
  async list(
    cmSheetId: number,
    pageSize: number,
    pageNumber: number,
    queryParams?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetCmSheetAvailableCertificationsResponse> {
    const params = queryParams ? createQueryParamString(queryParams) : "";

    const response =
      await httpClient.get<GetCmSheetAvailableCertificationsResponse>(
        `v1/cm-sheets/${cmSheetId}/available-certifications?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
        { signal },
      );
    return response;
  },
};

export default CmSheetAvailableCertificationsService;
